"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useMailingListForm = useMailingListForm;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var config = {
  id: '18b5cea6e6',
  url: 'https://storybook.us18.list-manage.com/subscribe/post',
  server: 'us18',
  fields: {
    u: '06a6fce3ab1327784d4342396',
    id: '18b5cea6e6'
  }
};

function useMailingListForm(onSubscribe) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      hasSubmitted = _useState2[0],
      setSubmitStatus = _useState2[1];

  var onSubmitForm = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(values) {
      var data, fullFields;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              data = new FormData();
              fullFields = _objectSpread(_objectSpread({}, config.fields), {}, {
                MERGE0: values.email
              });
              Object.keys(fullFields).forEach(function (key) {
                return data.append(key, fullFields[key]);
              });
              _context.next = 5;
              return fetch(config.url, {
                method: 'POST',
                body: data,
                mode: 'no-cors'
              });

            case 5:
              if (onSubscribe) {
                onSubscribe();
              }

              setSubmitStatus(true);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmitForm(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return [hasSubmitted, onSubmitForm];
}